import dayjs from 'dayjs';

export const dateStart = (startDate: string) => {
    const start = dayjs(startDate).utc();
    const now = dayjs().utc();
    const isSameYear = start.year() === now.year();
    if (!startDate) {
        return '';
    }
    if (isSameYear) {
        return start.format('D MMMM');
    }
    return start.format('D MMMM YYYY');
};

export const datePeriod = (startDate: string, endDate: string) => {
    if (!startDate && !endDate) {
        return 'Бессрочный';
    }
    const now = dayjs().utc();
    const start = dayjs(startDate).utc();
    const end = dayjs(endDate).utc();
    const isSameYear = start.year() === now.year();

    if (!startDate) {
        if (isSameYear) {
            return `До ${end.format('D MMMM')}`;
        }
        return `До ${end.format('D MMMM YYYY')}`;
    }

    if (!endDate) {
        if (isSameYear) {
            return `C ${start.format('D MMMM')}`;
        }
        return `C ${start.format('D MMMM YYYY')}`;
    }

    const isEqualDay = start.day() === end.day();
    const isEqualMonth = start.month() === end.month();
    const isEqualYear = start.year() === end.year();

    if (isEqualYear) {
        if (isEqualDay) {
            return end.format('D MMMM');
        }
        if (isEqualMonth) {
            return `${start.format('D')}-${end.format('D MMMM')}`;
        }
        return `${start.format('D MMMM')}-${end.format('D MMMM')}`;
    } else {
        if (isEqualDay) {
            return end.format('D MMMM YYYY');
        }
    }
    return `${start.format('D MMMM YYYY')}-${end.format('D MMMM YYYY')}`;
};
